<template>
  <s-section
    is-sub-section
    :title="cardsData.title"
    :class="`card-slider slider--${sliderId}`"
  >
    <div class="card-slider__items">
      <swiper
        :ref="`card-slider--${sliderId}`"
        :options="swiperOptions"
        @slide-change-transition-end="slideChangeHandler"
      >
        <component
          :is="slideType"
          v-for="item in mixedItems"
          :key="item.id"
          :item="item"
          @slideClick="gtmPush"
        >
        </component>
        <div
          v-show="needButtons"
          slot="pagination"
          class="swiper-pagination card-slider__pagination"
        ></div>
      </swiper>
      <button
        v-show="needButtons"
        class="swiper-button-next card-slider__btn card-slider__btn--next"
      >
        <svg-arrow></svg-arrow>
      </button>
      <button
        v-show="needButtons"
        class="swiper-button-prev card-slider__btn card-slider__btn--prev"
      >
        <svg-arrow></svg-arrow>
      </button>
    </div>
  </s-section>
</template>

<script>
import StoriesSlide from './items/StoriesSlide'

import SvgArrow from '~/assets/icons/swiper-arrow.svg'

import {Swiper} from 'vue-awesome-swiper'

export default {
  name: 'CardSlider',
  components: {
    StoriesSlide,
    Swiper,
    SvgArrow
  },
  props: {
    cardsData: {
      type: Object,
      default() {
        return {}
      }
    },
    sliderId: {
      type: String,
      default: 'only'
    },
    slideType: {
      type: Object,
      default: () => StoriesSlide
    }
  },
  data() {
    return {
      swiperOptions: {
        initialSlide: 0,
        navigation: {
          nextEl: `.slider--${this.sliderId} .swiper-button-next`,
          prevEl: `.slider--${this.sliderId} .swiper-button-prev`
        },
        lazy: {
          loadPrevNext: true,
          loadPrevNextAmount: 3
        },
        breakpoints: {
          992: {
            slidesPerGroup: 3,
            slidesPerView: 'auto',
            loop: this.cardsData?.items?.length > 3,
            grabCursor: this.cardsData?.items?.length > 3,
            loopFillGroupWithBlank: true
          },
          576: {
            slidesPerGroup: 2,
            slidesPerView: 'auto',
            loop: this.cardsData?.items?.length > 2,
            grabCursor: this.cardsData?.items?.length > 2,
            loopFillGroupWithBlank: true
          },
          0: {
            slidesPerView: this.cardsData?.items?.length > 1
              ? 'auto'
              : 1,
            slidesPerGroup: 1,
            grabCursor: this.cardsData?.items?.length > 1,
            loop: this.cardsData?.items?.length > 1,
            loopFillGroupWithBlank: true
          }
        },
        pagination: {
          // eslint-disable-next-line id-blacklist
          el: `.slider--${this.sliderId}  .swiper-pagination`,
          clickable: true
        }
      },
      mixedItems: []
    }
  },
  computed: {
    needButtons() {
      return (this.cardsData?.items?.length > 3 && this.$nuxt?.$breakpoints?.lLg)
        || (this.cardsData?.items?.length > 2 && this.$nuxt?.$breakpoints?.lSm && !this.$nuxt?.$breakpoints?.lLg)
        || (this.cardsData?.items?.length > 1 && this.$nuxt?.$breakpoints?.xs)
    }
  },
  beforeMount() {
    //Перемешиваем карточки методом тасования Фишера — Йетса
    const items = this.cardsData?.items?.slice()
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [items[i], items[j]] = [items[j], items[i]]
    }
    this.mixedItems = items
  },
  mounted() {
    if (this.slideType === StoriesSlide) {
      if (this.isSliderVisible()) {
        this.slideChangeHandler()
      } else {
        window.addEventListener('scroll', this.scrollHandler)
      }
    }
  },
  methods: {
    scrollHandler() {
      if (this.isSliderVisible()) {
        this.slideChangeHandler()
        window.removeEventListener('scroll', this.scrollHandler)
      }
    },
    slideChangeHandler() {
      if (this.slideType === StoriesSlide) {
        const slider = this.$refs[`card-slider--${this.sliderId}`]?.$swiper

        // Получаем индекс слайда
        const realIndex = slider?.realIndex || 0

        // Получаем количество карточек на слайде
        const slides = slider?.passedParams?.breakpoints[slider.currentBreakpoint]?.slidesPerGroup || 1

        // Выбираем из массива карточки, показанные в текущем слайде
        // и отправляем событие show для каждой
        for (let i = 0; i < Math.min(slides, this.mixedItems?.length); i++) {
          const link = this.mixedItems[realIndex + i]?.link.split('/').filter(Boolean)
          if (link) {
            this.gtmPush('show', link[link.length - 1])
          } else {
            console.log('err')
          }
        }
      }
    },
    isSliderVisible() {
      const sliderRect = this.$refs[`card-slider--${this.sliderId}`]?.$el?.getBoundingClientRect()
      return sliderRect?.bottom >= 0
        && sliderRect?.top <= (window?.innerHeight || document?.documentElement?.clientHeight)
    },
    gtmPush(action, label) {
      this.$gtmSendEvent({
        'event': 'gtm-selectel-component-successstory',
        'eventAction': action,
        'eventLabel': label
      })
    }
  }
}
</script>

<style lang="scss">
.card-slider {
  .card-slider__btn {
    width: 48px;
    height: 48px;

    display: flex;
    align-items: center;
    justify-content: center;

    border: 0 solid $gray50;
    outline: none;
    background: rgba(255, 255, 255, 0.9);

    box-sizing: border-box;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
    border-radius: 50%;

    transition: border 0.1s ease;

    @media (max-width: $breakpoint-md) {
      display: none;
    }

    svg {
      fill: $primary30;
      height: 24px;
      width: 24px;

      transition: fill 0.3s ease;
    }
  }

  .card-slider__btn:hover {
    border-width: 2px;

    svg {
      fill: $primary;
    }
  }

  .card-slider__btn--prev {
    transform: rotate(180deg);
    left: -17px;

    @media (max-width: $breakpoint-xl) {
      left: -2px;
    }

    @media (max-width: $breakpoint-lg) {
      left: 4px;
    }
  }

  .card-slider__btn--next {
    right: -17px;

    @media (max-width: $breakpoint-xl) {
      right: -2px;
    }

    @media (max-width: $breakpoint-lg) {
      right: 4px;
    }
  }

  .card-slider__pagination {
    display: none;
    bottom: -4px !important;

    @media (max-width: $breakpoint-md) {
      display: initial;
    }

    .swiper-pagination-bullet {
      background: $gray;
      opacity: 1;
    }

    .swiper-pagination-bullet-active {
      background: $primary30;
      opacity: 1;
    }
  }

  .card-slider__btn:after {
    content: unset;
  }
}

.card-slider__items {
  .swiper-container {
    margin: -20px -3px;
    padding: 20px 2px;

    @media (max-width: $breakpoint-md) {
      margin-bottom: 0;
      padding-bottom: 40px;
      margin-right: -10px;
      padding-right: 10px;
      margin-left: -10px;
      padding-left: 10px;
    }
  }

  .swiper-slide {
    box-sizing: border-box;
    height: auto;
    margin-right: 16px;
    width: calc((100% - 32px) / 3);

    @media (max-width: $breakpoint-lg) {
      width: calc((100% - 16px) / 2);
    }

    @media (max-width: $breakpoint-sm) {
      width: calc(100% - 16px);
    }
  }
}
</style>